import React, { useState } from 'react';
import { SafeAreaView, View } from 'react-native';
import { Text, Input, Button } from 'react-native-elements';
import Firebase from '../components/FirebaseContext';
import Toast from 'react-native-root-toast';

export default function Login(): JSX.Element {
	const auth = Firebase.auth();
	const [loading, setLoading] = useState(false);
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');

	return (
		<SafeAreaView style={{ flex: 1, backgroundColor: '#fff' }}>
			<View style={{ flex: 1, paddingTop: 40, paddingHorizontal: 20 }}>
				<Text style={{ fontWeight: '700', fontSize: 16, marginBottom: 20, textAlign: 'center' }}>
					Agent Data Capture Login
				</Text>
				<Input
					placeholder="Email"
					value={email}
					textContentType="emailAddress"
					onChangeText={(text) => {
						setEmail(text);
					}}
				/>
				<Input
					placeholder="Password"
					value={password}
					textContentType="password"
					secureTextEntry={true}
					onChangeText={(text) => {
						setPassword(text);
					}}
				/>
				<Button
					title="Login"
					buttonStyle={{ backgroundColor: '#275036', paddingVertical: 12 }}
					onPress={async () => {
						setLoading(true);
						//save the form
						try {
							await auth.signInWithEmailAndPassword(email.trim(), password);
						} catch (error) {
							setLoading(false);
							Toast.show('Email or password incorrect', {
								duration: 10000,
								position: 72,
								shadow: true,
								animation: true,
								hideOnPress: true,
								delay: 0,
								backgroundColor: '#b90000',
							});
						}
					}}
					loading={loading}
				/>
				<Text style={{ marginTop: 20, textAlign: 'center' }}>Forgot password?</Text>
			</View>
		</SafeAreaView>
	);
}
